import { render } from "./ComparisonCard.vue?vue&type=template&id=061e8400&scoped=true"
import script from "./ComparisonCard.vue?vue&type=script&lang=js"
export * from "./ComparisonCard.vue?vue&type=script&lang=js"

import "./ComparisonCard.vue?vue&type=style&index=0&id=061e8400&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e8400"]])

export default __exports__